import React from "react";
import AppBase from '../appBase';
import {getCurrentShortcutsVersion, getCurrentUserDatas, getCurrentVersion, setCurrentShortcutsList, setCurrentUserDatas} from "../../utils/software.js"
import {apiGetUserDatas} from "../../utils/apis.js"
import { apiGetSsoUserDatasOrCreate } from "../../utils/apis.js";
import Icon from "../../components/bases/icone/icon";
import Button from "../../components/bases/button/button.js";
import Tooltip from "../../components/bases/tooltips/tooltip";
import SelectLanguage from '../../components/bases/selectlanguage/selectlanguage.js';
import SelectKeyboard from "../../components/bases/selectkeyboard/selectkeyboard.js";
import { getUserDefaultLayout } from '../../utils/software.js';
import { GetIsFTVAChrome } from "../../utils/software.js";
import DownloadChromium from "./appcomponents/downloadchrome/downloadchrome.js";
import "../appstyles/login.css"

import imgdeconnect from "./assets/login/deconnect.png"

import logo from "../../assets/logoEasyTT.png"
import ftva from "../../assets/ftva.png"

import getText from "../../utils/language.js"

import imgUser from "./assets/login/simpleuser.png"
import imgEnter from "./assets/login/enter.png"
import imgSso from "./assets/login/sso.png"


import { apiSsoLogin, apiSsoLogout } from "../../utils/ssoapis.js";
import { apiSsoGetDomain } from "../../utils/ssoapis.js";
import { apiSsoGetMe } from "../../utils/ssoapis.js";

import { initGrammalecte, checkTextWithSuggestions, initSpellchecker, nspellCheckWord } from "../../utils/grammalecteClient.js";

class AppLogin extends AppBase
{

    constructor (props)
    {
      super(props);

      var memoid = false;
      var username = "";
      var id = 0;
      this.sso = false;
      this.token="";

      const token = document.cookie
        .split('; ')
        .find(row => row.startsWith('ssoAuthToken='))
        ?.split('=')[1];

      if (token) {
        this.token = token;
        this.sso = true;
        
        
        // ici on continue l'identification par token
      }
      else
      {
        
        const userdatas = getCurrentUserDatas();
        if (userdatas != null)
          id = userdatas.id;


        if (id === 0)
        {
            if (userdatas.memoid)
            {
              username = userdatas.username;
              memoid = userdatas.memoid;
            }

            if (userdatas.sso === 1)
            {
                username="";
                memoid = false;
            }
        }
        else
        {
            memoid = userdatas.memoid;
        }

      }
      this.state ={
          email:username,
          mdp:"",
          errorMsg: "",
          memoid:memoid,
          id: id,
      }

      this.ondeconnect = this.ondeconnect.bind(this);
      this.getMeCallBack = this.getMeCallBack.bind(this);
      
      this.onvalide = this.onvalide.bind(this);
      this.formSubmit = this.formSubmit.bind(this);
      this.apiReturn = this.apiReturn.bind(this);
      
      this.onkeyPress = this.onkeyPress.bind(this)

      this.onvalidesso = this.onvalidesso.bind(this);
  
        
  
      this.mdpInput = React.createRef()
      this.memoid = React.createRef()
      this.emailInput = React.createRef()

    }

    async componentDidMount()
    {
        
        if (this.sso)
        {
          document.cookie = 'ssoAuthToken=; path=/; domain='+apiSsoGetDomain()+'; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
          apiSsoGetMe(this.token, this.getMeCallBack);
        }

        await initGrammalecte();
        await initSpellchecker(); // nspell
    }

    getMeCallBack(datas)
    {
      

      if (datas)
      {
        
        // derniere api, recherche d'un user sso ou create
        apiGetSsoUserDatasOrCreate(datas.user, this.apiReturn);
      }
    }

    canClose()
    {
        return true;

    }

    onkeyPress(e)
    {
      
      if (e.code == "Enter") this.formSubmit();
    }

    onvalide()
    {
      this.formSubmit();
    }


    onvalidesso()
    {
      apiSsoLogin(null);
    }
    
    formSubmit()
    {
      
      var msgobl = getText(8,6, this.context.language);

      this.setState({errorMsg:""})
      if (this.state.email.trim()=="")  { this.emailInput.current.focus();
          this.setState({errorMsg:msgobl})
              return;}
      if (this.state.mdp.trim()=="")  { this.mdpInput.current.focus();
          this.setState({errorMsg:msgobl})
          return;}
  
      document.body.style.cursor = "wait";
      apiGetUserDatas(this.state.email, this.state.mdp, this.apiReturn);

    }


    apiReturn(datas)
    {
       
       document.body.style.cursor = "default";
       var msgerr = getText(8,7, this.context.language);


       if ((datas == null) || (!datas.ret))
      { this.emailInput.current.focus();
          this.setState({errorMsg:msgerr})
          return;
      }


      const userdatas = 
      {
          username: this.state.email,
          memoid: this.state.memoid,
          id: datas.users[0].id,
          token: datas.token,
          droits: datas.users[0].droits,
          sso: datas.users[0].sso,
          datas: datas.users[0],
          config: getUserDefaultLayout(datas.users[0]),
          options: JSON.parse(datas.users[0].options),
      }



      

      setCurrentUserDatas(userdatas);



      console.log("current user data ", datas.users[0])
      console.log("all current user data ", userdatas)
      var keyboarduser = "{}";
      if (GetIsFTVAChrome()!="")
      {
        keyboarduser = datas.users[0].keyboardchromium;
        console.log("load keyboard chromium values");
        if (keyboarduser ==="{}")
        {
          console.log("load keyboard values");
          keyboarduser = datas.users[0].keyboard;
        }
      }
      else
      {
        console.log("load keyboard values");
        keyboarduser = datas.users[0].keyboard;
      }

      if (keyboarduser !== "{}")
      {
          // datas = {version: "xxx", shortcuts: shortcuts}
          const keyboard = JSON.parse(keyboarduser);

          if (keyboard.version === getCurrentShortcutsVersion())
          {
            setCurrentShortcutsList(JSON.parse(keyboard.shortcuts), false);
          }
      }

      

      this.setState({id:userdatas.id});

      this.props.onnavigate("login");
      
    }

    mergeMissing(target, source) {
        for (const key in source) {

            // clé absente => copie directe
            if (!(key in target)) {
                target[key] = structuredClone(source[key]);
            }

            // fusion des arrays
            else if (
                Array.isArray(target[key]) &&
                Array.isArray(source[key])
            ) {
                // ajoute uniquement les éléments absents
                target[key] = [
                    ...target[key],
                    ...source[key].filter(
                        item => !target[key].includes(item)
                    )
                ];
            }

            // fusion récursive des objets
            else if (
                typeof target[key] === 'object' &&
                target[key] !== null &&
                typeof source[key] === 'object' &&
                source[key] !== null
            ) {
                this.mergeMissing(target[key], source[key]);
            }
        }

        return target;
    }

    ondeconnect()
    {

      const userdatas = getCurrentUserDatas();

      const sso = userdatas.sso;

      userdatas.id = 0;
      setCurrentUserDatas(userdatas);
      this.setState({id:0});

      if (sso===1)
        apiSsoLogout();
      else
        this.props.onnavigate("logout");
    }


    renderConnect()
    {

      var connecttext = getText(8,2, this.context.language);

      var titletext = getText(8,1, this.context.language);
      var mailtext = getText(8,3, this.context.language);
      var memotext = getText(8,4, this.context.language);
      var passwordtext = getText(8,5, this.context.language);

      var libsso = getText(8,8, this.context.language);
      var tpsso = getText(8,9, this.context.language);

      
         return (
              <>
              <div className="login-div-login">
              <form className="login-formLogin" >
              
              <div className="login-formUser-titre">
              {titletext}
              
              </div>
              
            <div className="label-formUser-titre-image">
              <Icon image={imgUser} width="20%" height="20%"/>
            </div>
  
              <label className="login-formUser-label">
                      {mailtext}
                      <input className="login-formUser-input"   
                      name="email"
                      type="text"
                      autoComplete="new-password"
                      onKeyDown={this.onkeyPress}
                      ref={this.emailInput}
                      onChange={e => this.setState({email:e.target.value})}
                      value={this.state.email}
                      required />
                </label>
  
                
                      <label className="login-formUser-label">
                      <input 
                      name="memoid"
                      type="checkbox"
                      
                      ref={this.memoidInput}
                      onChange={e => this.setState({memoid:e.target.checked})}
                      
                      
                      checked={this.state.memoid}
                      required />
                      <span style={{fontSize:"13px"}}>
                      {memotext}
                      </span>
                      
                      
                      </label>
  
  
                <label className="login-formUser-label">
                      {passwordtext}
                      <input className="login-formUser-input"
                      name="mdp"
                      type="password"
                      ref={this.mdpInput}
                      onChange={e => this.setState({mdp:e.target.value})}
                      onKeyDown={this.onkeyPress}
                      value={this.state.mdp}
                      required />
                  </label>
                
                <label className="login-formUser-label-red">
                  {this.state.errorMsg}
                </label>
                <label className="login-formUser-label-red">
                </label>
                <div>

                
                <div className="login-div-login-button">
                
                <Tooltip text= {connecttext}>
                  <Button image={imgEnter} width={64} height={64} onClick={this.onvalide}/>
                </Tooltip>
                </div>
                </div>


                <div className="login-div-login-sso">
                  {libsso}&nbsp;:&nbsp;
                <Tooltip text= {tpsso}>
                  <Button image={imgSso} width={24} height={24} onClick={this.onvalidesso}/>
                </Tooltip>

                </div>
  
              </form>
              </div> 
              </>
         )
    }
  


    renderUnconnect()
    
    {
        
        var unconnecttext = getText(8,0,this.context.language);
         return (
              <>
              <div className="login-div-logout">
                <Tooltip text= {unconnecttext}>
                  <Button image={imgdeconnect} width={256} height={256} onClick={this.ondeconnect}/>
                  </Tooltip>
              </div> 
              </>
         )
    }
  


    renderUsers()
    {
  
        if(this.state.id == 0)
          return (this.renderConnect())
        return (this.renderUnconnect())
  
    }
  


    render () {
            const version = getCurrentVersion();

            var download = (
              <></>
            );
            if (GetIsFTVAChrome() === "")
              download = (<>
                <DownloadChromium/>
              </>)


            return (
              <>
              <div className="login-fulldiv">
                <div className="login-imglogo">
                
                <Icon image={logo} height="100%" width="100%"/>
                <div style={{color:"white", fontSize:10}}><br/><br/>{version}</div>
                
                
                </div>
                
                <div className="login-imgftva">
                <img  src={ftva} alt="imgFTVA" style={{float:"right"}}/>
                <SelectLanguage popup={false} horizontal={true}/>
                <SelectKeyboard  horizontal={true}/>
                {download}
                
                </div>

                {this.renderUsers()}
                
              </div>
    
              </>
    
                )
      }
    }

export default AppLogin;